"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendCodeLoading = void 0;
var _actionGenerator = require("../../types/redux/actionGenerator");
var _types = require("./types");
const sendCodeLoading = exports.sendCodeLoading = (0, _actionGenerator.actionGenerator)(_types.ETwoFactorPhoneActionTypes.SendCodeLoading);